module.exports = "https://cdn2-fs.clearscore.com/flux/images/1824b69af880cfbebec50a01c80f40c6.jpg";